import { useEffect, useState } from "react";
import { Loading } from "@components";
import { message } from "antd";
import { Navigate } from "react-router-dom";
import * as API from "@api";

export default function ProjectPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!data) {
      API.Projects.create({
        name: `New Project`,
      })
        .then((res) => {
          if (!res || res?.error) {
            throw new Error("Error while creating project");
          }

          setData(res?.data);
        })
        .catch((err) => {
          return message.error(
            err?.message || "Error while creating project",
            2
          );
        });
    }
  }, [data]);

  if (data?.id) {
    return <Navigate to={`/projects/edit/${data?.id}`} />;
  }

  return <Loading />;
}
